<p-toast></p-toast>
<p-tabs [(value)]="activeTab" (valueChange)="onTabChange($event)" class="simulationPanel">
    <!-- simBlock -->
    <p-tablist class="simulationSettings">
        <p-tab value="simPanel" pTooltip="Total Population at Risk" tooltipPosition="left">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 20 20" fill="none">
                <path
                    d="M11 9H17.95C17.7 7.16667 16.9375 ************25 4.3375C14.3875 3.0625 12.8333 2.3 11 2.05V9ZM9 17.95V2.05C6.98333 2.3 5.3125 3.17917 3.9875 4.6875C2.6625 6.19583 2 7.96667 2 10C2 12.0333 2.6625 13.8042 3.9875 15.3125C5.3125 16.8208 6.98333 17.7 9 17.95ZM11 17.95C12.8333 17.7167 14.3917 16.9583 15.675 15.675C16.9583 14.3917 17.7167 12.8333 17.95 11H11V17.95ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6792 0.2625 13.8875 0.7875C15.0958 1.3125 16.1542 2.02*******0625 2.9375C17.9708 3.84583 18.6875 4.90417 19.2125 6.1125C****************20 8.61667 20 10C20 11.3667 19.7375 12.6583 19.2125 13.875C18.6875 15.0917 17.975 16.1542 17.*******0625C16.*******9708 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20Z"
                    fill="currentColor" />
            </svg></p-tab>
        <p-tab value="simOverview" pTooltip="Intervention Controls" tooltipPosition="left">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 17 17" fill="none">
                <path
                    d="M8 18V12H10V14H18V16H10V18H8ZM0 16V14H6V16H0ZM4 12V10H0V8H4V6H6V12H4ZM8 10V8H18V10H8ZM12 6V0H14V2H18V4H14V6H12ZM0 4V2H10V4H0Z"
                    fill="currentColor" />
            </svg>
        </p-tab>
        <p-tab value="costingData" pTooltip="Costmetrics Data" tooltipPosition="left">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 20 19" fill="none">
                <path
                    d="M14 9C14.2833 9 14.5208 8.90417 14.7125 8.7125C14.9042 8.52083 15 8.28333 15 8C15 7.71667 14.9042 7.****************2875C14.5208 7.09583 14.2833 7 14 7C13.7167 7 13.4792 7.09583 13.2875 7.2875C13.0958 7.47917 13 7.71667 13 8C13 8.28333 13.0958 8.52083 13.2875 8.7125C13.4792 8.90417 13.7167 9 14 9ZM6 7H11V5H6V7ZM2.5 19C1.93333 17.1 1.*******2042 0.*******3125C0.*******4208 0 9.48333 0 7.5C0 5.96667 0.533333 4.66667 1.6 3.6C2.66667 2.53333 3.96667 2 5.5 2H10.5C10.9833 1.36667 11.5708 0.875 12.2625 0.525C12.9542 0.175 13.7 0 14.5 0C14.9167 0 15.2708 0.145833 15.5625 0.4375C15.8542 0.729167 16 1.08333 16 1.5C16 1.6 15.9875 1.7 15.9625 1.8C15.9375 1.9 15.9083 1.99167 15.875 2.075C15.8083 2.25833 15.7458 2.44583 15.6875 2.6375C15.6292 2.82917 15.5833 3.025 15.55 3.225L17.825 5.5H20V12.475L17.175 13.4L15.5 19H10V17H8V19H2.5ZM4 17H6V15H12V17H14L15.55 11.85L18 11.025V7.5H17L13.5 4C13.5 3.66667 13.5208 3.34583 13.5625 3.0375C13.6042 2.72917 13.6667 2.41667 13.75 2.1C13.2667 2.23333 12.8417 2.4625 12.475 2.7875C12.1083 3.1125 11.8417 3.51667 11.675 4H5.5C4.53333 4 3.70833 4.34167 3.025 5.025C2.34167 5.70833 2 6.53333 2 7.5C2 9.13333 2.*******7292 2.*******2875C3.*******8458 3.56667 15.4167 4 17Z"
                    fill="currentColor" />
            </svg>
        </p-tab>
        <!-- <p-tab value="t3Params" pTooltip="T3 Interventions" tooltipPosition="left">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none">
                <path
                    d="M12 11.75C12.4142 11.75 12.75 12.0858 12.75 12.5V13.25H13.5C13.9142 13.25 14.25 13.5858 14.25 14C14.25 14.4142 13.9142 14.75 13.5 14.75H12.75V15.5C12.75 15.9142 12.4142 16.25 12 16.25C11.5858 16.25 11.25 15.9142 11.25 15.5V14.75H10.5C10.0858 14.75 9.75 14.4142 9.75 14C9.75 13.5858 10.0858 13.25 10.5 13.25H11.25V12.5C11.25 12.0858 11.5858 11.75 12 11.75Z"
                    fill="currentColor" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M12 9.25C9.37665 9.25 7.25 11.3767 7.25 14C7.25 16.6234 9.37665 18.75 12 18.75C14.6234 18.75 16.75 16.6234 16.75 14C16.75 11.3767 14.6234 9.25 12 9.25ZM8.75 14C8.75 12.2051 10.2051 10.75 12 10.75C13.7949 10.75 15.25 12.2051 15.25 14C15.25 15.7949 13.7949 17.25 12 17.25C10.2051 17.25 8.75 15.7949 8.75 14Z"
                    fill="currentColor" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M11.948 1.25C11.0495 1.24997 10.3003 1.24995 9.70552 1.32991C9.07773 1.41432 8.51093 1.59999 8.05546 2.05546C7.*******************32 3.07773 7.32991 3.70552C7.27081 4.14512 7.2554 4.66909 7.2514 5.27533C6.60288 5.29614 6.02475 5.33406 5.51098 5.40314C4.33856 5.56077 3.38961 5.89288 2.64124 6.64125C1.89288 7.38961 1.56076 8.33856 1.40314 9.51098C1.24997 10.6502 1.24998 12.1058 1.25 13.9436V14.0564C1.24998 15.8942 1.24997 17.3498 1.40314 18.489C1.56076 19.6614 1.89288 20.6104 2.64124 21.3588C3.38961 22.1071 4.33856 22.4392 5.51098 22.5969C6.65018 22.75 8.1058 22.75 9.94354 22.75H14.0564C15.8942 22.75 17.3498 22.75 18.*******5969C19.6614 22.4392 20.6104 22.1071 21.3588 21.3588C22.1071 20.6104 22.4392 19.6614 22.5969 18.489C22.75 17.3498 22.75 15.8942 22.75 14.0565V13.9436C******************5 10.6502 22.5969 9.51098C22.4392 8.33856 22.1071 7.38961 21.3588 6.64125C20.6104 5.89288 19.6614 5.56077 18.489 5.40314C17.9752 5.33406 17.3971 5.29614 16.7486 5.27533C16.7446 4.66909 16.7292 4.14512 16.6701 3.70552C16.5857 3.07773 16.4 2.51093 15.9445 2.05546C15.4891 1.59999 14.9223 1.41432 14.2945 1.32991C13.6997 1.24995 12.9505 1.24997 12.052 1.25H11.948ZM15.2482 5.25178C15.244 4.68146 15.23 4.25125 15.1835 3.9054C15.1214 3.44393 15.0142 3.24644 14.8839 3.11612C14.7536 2.9858 14.5561 2.87*******0946 2.81654C13.6116 2.7516 12.964 2.75 12 2.75C11.036 2.75 10.3884 2.7516 9.90539 2.81654C9.44393 2.87858 9.24643 2.9858 9.11612 3.11612C8.9858 3.24644 8.87858 3.44393 8.81654 3.9054C8.77004 4.25125 8.75602 4.68146 8.7518 5.25178C9.12993 5.25 9.52694 5.25 9.94358 5.25H14.0564C14.4731 5.25 14.8701 5.25 15.2482 5.25178ZM3.7019 7.70191C4.12511 7.2787 4.70476 7.02503 ***********8976C6.73851 6.7516 8.09318 6.75 10 6.75H14C15.9068 6.75 17.2615 6.7516 18.2892 6.88976C19.2952 7.02503 19.8749 7.2787 20.2981 7.70191C20.7213 8.12512 20.975 8.70476 21.1102 9.71085C21.2484 10.7385 21.25 12.0932 21.25 14C21.25 15.9068 21.2484 17.2615 21.1102 18.2892C20.975 19.2952 20.7213 19.8749 20.2981 20.2981C19.8749 20.7213 19.2952 20.975 18.2892 21.1102C17.2615 21.2484 15.9068 21.25 14 21.25H10C8.09318 21.25 6.73851 21.2484 5.71085 21.1102C4.70476 20.975 4.12511 20.7213 3.7019 20.2981C3.27869 19.8749 3.02503 19.2952 2.88976 18.2892C2.75159 17.2615 2.75 15.9068 2.75 14C2.75 12.0932 2.75159 10.7385 2.88976 9.71085C3.02503 8.70476 3.27869 8.12512 3.7019 7.70191Z"
                    fill="currentColor" />
            </svg>
        </p-tab> -->
    </p-tablist>
    <div class="rounded-lg border border-slate-200 bg-white shadow-sm overflow-hidden simBlock"
        [ngClass]="{ simBlockExtended: isSimBlockExpanded }">
        <div class="flex justify-between bg-slate-50 border-b border-slate-200 text-xs text-slate-500">
            <div class="flex items-center gap-3 px-3 py-2">
                <p-checkbox [binary]="true" [ngModel]="isAllSelected()" (onChange)="toggleSelectAll($event.checked)"
                    inputId="select-all-simulations"></p-checkbox>
                <span class="font-medium">Simulation title</span>
            </div>
            <div class="flex items-center px-3 py-2 font-medium">Date created</div>
            <div class="flex items-center px-3 py-2 font-medium justify-end">
                Actions
                <button type="button" class="p-1 rounded hover:bg-slate-100 ml-2"
                    (click)="isSimBlockExpanded = !isSimBlockExpanded" title="Minimize" aria-label="Minimize">
                    <i class="pi" [ngClass]="isSimBlockExpanded ? 'pi-window-maximize' : 'pi-window-minimize'"></i>
                </button>
            </div>
        </div>

        <!-- Simulation list with per-row actions -->
        <div class="overflow-auto simCollapse">
            @for (sim of simulations; track trackById($index, sim)) {
            <div [attr.data-sim-id]="sim.id" class="flex flex-col border-b last:border-b-0 border-slate-100 text-sm">
                <div class="flex justify-between items-center">
                    <div class="flex items-center gap-3 px-3 py-2">
                        <p-checkbox [binary]="true" [ngModelOptions]="{ standalone: true }"
                            [ngModel]="selectedSimulationIds.has(sim.id)"
                            (onChange)="toggleSelection(sim.id, $event.checked)" [inputId]="'sim-' + sim.id">
                        </p-checkbox>
                        <div class="flex items-center gap-2">
                            <span class="inline-block w-2.5 h-0.5 rounded-sm"
                                [style.background]="sim.color || '#64748b'"></span>
                            @if (!sim.editing) {
                            <span class="text-slate-700 cursor-pointer" (click)="onSimulationTitleClick(sim)">{{
                                sim.title }}</span>
                            } @else {
                            <input type="text" class="px-2 py-1 border rounded text-sm" [ngModel]="sim.title"
                                (ngModelChange)="sim.title = $event" (keyup.enter)="saveEdit(sim, sim.title)"
                                (blur)="saveEdit(sim, sim.title)" (keyup.escape)="cancelEdit(sim)" autofocus
                                style="max-width: 10rem;" />
                            }
                        </div>
                    </div>
                    <div class="px-3 py-2 text-xs text-slate-500 hidden-date">
                        {{ relativeTime(sim.createdAt) }}
                    </div>
                    <div class="px-3 py-2 flex items-center justify-end gap-2">
                        <button type="button" class="p-1 rounded hover:bg-slate-100" (click)="openPayloadDialog(sim)"
                            title="View details" aria-label="View details">
                            <i class="pi pi-eye text-slate-600"></i>
                        </button>
                        <!-- Edit disabled for Basic Simulation -->
                        <button type="button" class="p-1 rounded hover:bg-slate-100" (click)="onEditClick(sim)"
                            title="Edit" aria-label="Edit"
                            [disabled]="sim.__protected || (sim.title || '').trim().toLowerCase() === 'Basic Simulation'">
                            <i class="pi pi-pencil text-slate-600"></i>
                        </button>
                        <!-- Delete disabled for Basic Simulation -->
                        <button type="button" class="p-1 rounded hover:bg-red-50" (click)="openDeleteConfirm(sim)"
                            title="Delete" aria-label="Delete"
                            [disabled]="sim.__protected || (sim.title || '').trim().toLowerCase() === 'Basic Simulation'">
                            <i class="pi pi-trash text-red-600"></i>
                        </button>
                    </div>
                </div>
            </div>
            }
        </div>


        <div class="flex items-center justify-between px-3 py-3 bg-slate-50 border-t border-slate-200">
            <div class="flex items-center gap-2">
                <button type="button" class="px-3 py-2 rounded border f12 text-slate-700 bg-red-600 text-white"
                    (click)="deleteSelected()" [disabled]="selectedSimulationIds.size === 0">
                    <i class="pi pi-trash mr-2"></i>
                    Delete selected
                </button>
            </div>
            <div class="flex items-center gap-3">
                <button type="button" class="px-3 py-2 f12 rounded bg-blue-600 text-white"
                    (click)="openSimNameDialogForAdd()">
                    <i class="pi pi-play mr-2"></i>
                    Add simulation
                </button>
            </div>
        </div>
    </div>

    <!-- Simulation name dialog -->
    <p-dialog header="Enter simulation name" [modal]="true" [(visible)]="simNameDialogVisible"
        [style]="{ width: '25rem' }">
        <div class="flex items-center gap-4 mb-4">
            <input pInputText id="simName" class="flex-auto p-inputtext" [(ngModel)]="simNameInput"
                autocomplete="off" />
        </div>
        <div class="flex justify-end gap-2">
            <p-button label="Cancel" severity="secondary" (click)="simNameDialogVisible = false" />
            <p-button [label]="simDialogMode === 'add' ? 'Create Simulation' : 'Update'" (click)="onSimNameSave()" />
        </div>
    </p-dialog>

    <!-- Confirmation dialog -->
    <p-dialog header="Confirm delete" [modal]="true" [(visible)]="confirmDeleteVisible" [style]="{ width: '26rem' }">
        <div class="text-sm text-slate-700 mb-4">
            Do you want to delete "<span class="font-semibold">{{ confirmDeleteTarget?.title }}</span>"?
        </div>
        <div class="flex justify-end gap-2">
            <p-button label="Cancel" severity="secondary" (click)="confirmDeleteCancel()" />
            <p-button label="Delete" severity="danger" (click)="confirmDeleteProceed()" />
        </div>
    </p-dialog>

    <!-- Payload details dialog (nested view + download) -->
    <p-dialog header="Simulation payload" [modal]="true" [(visible)]="payloadDialogVisible"
        [style]="{ width: '48rem' }">
        <div class="text-xs text-slate-600 mb-3">
            <div><span class="font-semibold">Title:</span> {{ payloadDialogTitle }}</div>
            <div><span class="font-semibold">Run ID:</span> {{ payloadDialogRunId || '-' }}</div>
        </div>

        <!-- Parameters -->
        <div class="rounded border border-slate-200 bg-slate-50/60 mb-3">
            <div class="px-3 py-2 text-xs font-semibold text-slate-700">Parameters</div>
            <div class="px-3 pb-2">
                @if (dialogScalarPairs.length) {
                <div class="mb-2">
                    <div class="text-xs font-medium text-slate-500 mb-1">Global switches</div>
                    <ul class="list-disc ml-5">
                        @for (p of dialogScalarPairs; track p) {
                        <li>
                            <span class="text-slate-600">{{ p.key }}</span>
                            <span class="text-slate-900 font-semibold ml-2">{{ p.val }}</span>
                        </li>
                        }
                    </ul>
                </div>
                }
                @for (grp of dialogParamGroups; track grp) {
                <div class="mb-2">
                    <div class="text-xs font-medium text-slate-500 mb-1">{{ grp.name }}</div>
                    <ul class="list-disc ml-5">
                        @for (kv of grp.pairs; track kv) {
                        <li>
                            <span class="text-slate-600">{{ kv.key }}</span>
                            <span class="text-slate-900 font-semibold ml-2">{{ kv.val }}</span>
                        </li>
                        }
                    </ul>
                </div>
                }
            </div>
        </div>

        <!-- Costmetrics -->
        <div class="rounded border border-slate-200 bg-slate-50/60">
            <div class="px-3 py-2 text-xs font-semibold text-slate-700">Costmetrics</div>
            <div class="px-3 pb-2">
                @for (grp of dialogCostGroups; track grp) {
                <div class="mb-2">
                    <div class="text-xs font-medium text-slate-500 mb-1">{{ grp.name }}</div>
                    <ul class="list-disc ml-5">
                        @for (kv of grp.pairs; track kv) {
                        <li>
                            <span class="text-slate-600">{{ kv.key }}</span>
                            <span class="text-slate-900 font-semibold ml-2">{{ kv.val }}</span>
                        </li>
                        }
                    </ul>
                </div>
                }
            </div>
        </div>

        <div class="flex justify-end gap-2 mt-4">
            <p-button label="Close" severity="secondary" (click)="payloadDialogVisible = false" />
            <p-button label="Download Excel" icon="pi pi-download" (click)="downloadPayloadExcel()" />
        </div>
    </p-dialog>

    <p-tabpanels class="simulationFilters">
        <!-- Simulation Overview -->
        <p-tabpanel value="simPanel">
            <div>
                @if (isLoading) {
                <div class="space-y-6 p-4">
                    <div class="h-6 w-64 bg-gray-200 rounded animate-pulse"></div>
                    <div class="flex flex-col md:flex-row md:items-stretch md:gap-6 gap-6">
                        <div class="h-64 bg-gray-100 rounded animate-pulse flex-1 md:max-w-[360px]"></div>
                        <div class="flex-1">
                            <div class="flex flex-wrap gap-4">
                                <div
                                    class="h-24 bg-gray-100 rounded animate-pulse basis-full sm:basis-[calc(50%-0.5rem)] flex-grow">
                                </div>
                                <div
                                    class="h-24 bg-gray-100 rounded animate-pulse basis-full sm:basis-[calc(50%-0.5rem)] flex-grow">
                                </div>
                                <div
                                    class="h-24 bg-gray-100 rounded animate-pulse basis-full sm:basis-[calc(50%-0.5rem)] flex-grow">
                                </div>
                                <div
                                    class="h-24 bg-gray-100 rounded animate-pulse basis-full sm:basis-[calc(50%-0.5rem)] flex-grow">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="space-y-6">
                        <div class="h-4 w-40 bg-gray-200 rounded animate-pulse"></div>
                        <div class="h-2 w-full bg-gray-100 rounded animate-pulse"></div>
                        <div class="h-4 w-40 bg-gray-200 rounded animate-pulse"></div>
                        <div class="h-2 w-full bg-gray-100 rounded animate-pulse"></div>
                        <div class="h-4 w-40 bg-gray-200 rounded animate-pulse"></div>
                        <div class="h-2 w-full bg-gray-100 rounded animate-pulse"></div>
                    </div>
                </div>
                }

                @if (!isLoading && activeTab === 'simPanel') {
                <div class="space-y-6">
                    <app-simulation-overview (chartReady)="onOverviewChartReady()"></app-simulation-overview>
                </div>
                }
            </div>
        </p-tabpanel>

        <!-- Simulation Controls -->
        <p-tabpanel value="simOverview">
            <app-simulation-controls></app-simulation-controls>
        </p-tabpanel>

        <!-- Costing Data -->
        <p-tabpanel value="costingData">
            <app-costing-data></app-costing-data>
        </p-tabpanel>
        <!-- <p-tabpanel value="t3Params">
            <app-t3-stats></app-t3-stats>
        </p-tabpanel> -->
    </p-tabpanels>
</p-tabs>